import { render } from "./inputweight.vue?vue&type=template&id=6bb8f6e0"
import script from "./inputweight.vue?vue&type=script&lang=js"
export * from "./inputweight.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT_REPOS\\pilot-tools\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__